import styles from "assets/jss/default/layouts/adminStyle.js";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect, useRef, useState } from "react";
import cx from "classnames";

const useStyles = makeStyles(styles);

function useDefaultRootLayout() {
  const classes = useStyles();

  const [miniActive, setMiniActive] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const color = "white";
  const bgColor = "blue";
  const scrollRef = useRef({ update() {} });

  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive
    });

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", resizeFunction);
    };
  });

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return {
    handleDrawerToggle,
    sidebarMinimize,
    mainPanelClasses,
    classes,
    color,
    bgColor,
    scrollRef,
    miniActive,
    mobileOpen
  };
}

export function getActiveRoute(routes) {
  let activeRoute = "Onyx Insight";
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].collapse) {
      let collapseActiveRoute = getActiveRoute(routes[i].views);
      if (collapseActiveRoute !== activeRoute) {
        return collapseActiveRoute;
      }
    } else {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].name;
      }
    }
  }
  return activeRoute;
}

export default useDefaultRootLayout;
